import React, { useState } from 'react';
import '../../../styles/modal.css';

const JiraSyncModal = ({ isOpen, onClose, onSync, project }) => {
  const [selectedAccount, setSelectedAccount] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Mock JIRA accounts - in a real app, these would come from an API or context
  const jiraAccounts = [
    { id: 1, name: 'Jira Cloud - Development', url: 'https://dev.atlassian.net' },
    { id: 2, name: 'Jira Cloud - Production', url: 'https://prod.atlassian.net' },
    { id: 3, name: 'Jira Server - On-Premise', url: 'https://jira.internal.company.com' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedAccount) {
      setError('Please select a JIRA account');
      return;
    }

    setIsLoading(true);
    setError(null);

    // Simulate API call to sync JIRA items
    setTimeout(() => {
      setIsLoading(false);
      
      // Find the selected account object
      const account = jiraAccounts.find(acc => acc.id === parseInt(selectedAccount));
      
      // Call the onSync callback with the selected account
      onSync(project.id, account);
      
      // Close the modal
      onClose();
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div data-rt-modal-overlay className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) { const b = e.currentTarget.querySelector('[data-rt-modal-close], .close-btn, .modal-close, button[aria-label="Close"], button[aria-label="close"]'); if (b) b.click(); } }}>
      <div className="modal-container">
        <div className="modal-header">
          <h2>Sync JIRA Items for {project ? project.name : 'Project'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-content">
          <p className="modal-description">
            Select the JIRA account to sync items from for <strong>{project ? project.name : 'this project'}</strong>.
            This will refresh all JIRA items (EPICs, Stories, Bugs) associated with this project.
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="jira-account">JIRA Account</label>
              <select 
                id="jira-account" 
                value={selectedAccount} 
                onChange={(e) => setSelectedAccount(e.target.value)}
                className="form-control"
              >
                <option value="">-- Select JIRA Account --</option>
                {jiraAccounts.map(account => (
                  <option key={account.id} value={account.id}>
                    {account.name} ({account.url})
                  </option>
                ))}
              </select>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn-secondary" 
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn-primary" 
                disabled={isLoading}
              >
                {isLoading ? 'Syncing...' : 'Sync JIRA Items'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JiraSyncModal;